// Русское склонение по числительному: 1 обращение, 2-4 обращения, 5-20 (в т.ч. 11-14) обращений.
export function pluralizeRu(count, one, few, many) {
    const n = Math.abs(count) % 100;
    const n1 = n % 10;
    if (n > 10 && n < 20) return many;
    if (n1 > 1 && n1 < 5) return few;
    if (n1 === 1) return one;
    return many;
}

// Список опций селектора «Строк»: базовые значения + текущее perPage, если оно нестандартное
// (страница /user-settings разрешает сохранить любое кратное 5 от 5 до 100 — если это значение
// не подставить в список, select рендерится пустым и пользователь не видит фактическую настройку).
export function perPageOptions(current, base = [15, 30, 50]) {
    const set = new Set(base);
    if (Number.isFinite(current)) set.add(current);
    return Array.from(set).sort((a, b) => a - b);
}
